import info from "../../info.json"

export default function Footer() {
  return <div className="text-[0.75rem] flex items-center justify-between  w-full text-toda-gray  ~text-gray-800">
    <div>BACK-OFFICE by TODAQ 2024</div>
    <div className="text-center">CORPORATE CONFIDENTIAL</div>
    <div> Build: {info.build} {info.env != "PROD" && info.env} </div>
  </div>
}
